import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { BPointsGamesResultListLayer } from '../components/GamesPoints/BPointsGamesResultListLayer'

export const BPointsGamesResulListPage = () => {
  return (
    <MasterLayout>
        <BPointsGamesResultListLayer />
    </MasterLayout>
  )
}
